<script setup>
defineEmits(['close', 'confirm']);

const $t = inject('$t');
</script>

<template>
  <HawkModalContainer content_class="w-[500px]" @close="$emit('close')">
    <div class="p-6">
      <div class="flex items-center gap-3 mb-4">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-warning-100 text-warning-600">
          <IconHawkAlertTriangle class="w-5 h-5" />
        </span>
        <h3 class="text-lg font-semibold text-gray-900">
          {{ $t('No data available') }}
        </h3>
      </div>
      <p class="text-sm text-gray-600 mb-6">
        {{ $t("Since the widget currently doesn't have any data, the next screen will show some sample data that will help in the visualization of the widgets.") }}
      </p>
      <div class="flex justify-end gap-3">
        <HawkButton color="primary" type="outlined" @click="$emit('close')">
          {{ $t('Cancel') }}
        </HawkButton>
        <HawkButton color="primary" @click="$emit('confirm')">
          {{ $t('Continue') }}
        </HawkButton>
      </div>
    </div>
  </HawkModalContainer>
</template>
